import { useEffect, useLayoutEffect, useState } from 'react';
import { bootSplashShowing, holdBootSplash, onBootSplashHidden, releaseBootSplash } from '../boot';
import { LoadingState } from './Ui';

/**
 * Keeps the boot splash from index.html on screen while the session is being checked, so the
 * animated mark runs from the first paint straight into the app. Once the splash is gone (a retry
 * after an error, or the watchdog), the plain loading panel stands in.
 */
export default function BootSplash({ label = 'Checking your session' }: { label?: string }) {
  const [showing, setShowing] = useState(bootSplashShowing);
  useLayoutEffect(() => { holdBootSplash(); return releaseBootSplash; }, []);
  useEffect(() => onBootSplashHidden(() => setShowing(false)), []);
  if (showing) return null;
  return <div className="full-state"><LoadingState label={label} /></div>;
}
